import React from "react";
import { useParams, Link } from "react-router-dom";
import "./About.css";
import DIRECTORS from "../data/directors";

export default function LeaderDetail() {
  const { slug } = useParams();
  const leader = DIRECTORS.find((d) => d.slug === slug);

  if (!leader) {
    return (
      <div style={{ padding: "var(--nav-height) 24px 40px" }}>
        <div className="container">
          <h2>Profile not found</h2>
          <p>The profile you are looking for does not exist.</p>
          <Link to="/leadership" className="btn btn-outline">← Back to Leadership</Link>
        </div>
      </div>
    );
  }

  const bioParagraphs = leader.bio
    .trim()
    .split(/\n{2,}/)
    .map((para) => para.replace(/\n/g, " ").trim())
    .filter(Boolean);

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero__bg" />
        <div className="container">
          <div className="about-hero__content">
            <span className="badge">👔 Leadership</span>
            <h1 className="about-hero__title">
              {leader.name} <em></em>
            </h1>
            <p className="about-hero__subtitle">{leader.designation}</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="leader-detail-grid">
            <div>
              <img src={leader.src} alt={leader.name} className="leader-detail__image" />
              <div style={{ marginTop: 16 }}>
                <Link to="/leadership" className="btn btn-outline">← Back</Link>
              </div>
            </div>

            <div className="leader-detail__bio">
              {bioParagraphs.map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
